import React from 'react';
import { Section, Card, Button } from './Shared';
export const Pricing = () => {
  return <>
      {/* Offers Section */}
      <Section bg="base" id="pricing" data-id="element-140">
        <div className="text-center mb-12" data-id="element-141">
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-dark" data-id="element-142">
            ELEGÍ TU MEGAKIT
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto items-start" data-id="element-143">
          {/* Card 1 */}
          <Card className="bg-white flex flex-col h-full" data-id="element-144">
            <div className="mb-6" data-id="element-145">
              <h3 className="font-playfair text-2xl font-bold text-dark mb-2" data-id="element-146">
                💅 MEGAKIT MÁS CLIENTAS
              </h3>
              <p className="font-montserrat text-sm font-bold text-gray-500 uppercase tracking-wide mb-4" data-id="element-147">
                6 Tomos + 4 Bonos
              </p>
              <p className="font-montserrat text-sm text-gray-600 mb-6" data-id="element-148">
                Ideal para: profesionales que quieren más clientas y un sistema
                de ventas claro
              </p>
              <div className="flex items-baseline gap-3 mb-6" data-id="element-149">
                <span className="font-montserrat text-xl text-gray-400 line-through" data-id="element-150">
                  $55.990
                </span>
                <span className="font-playfair text-4xl font-bold text-dark" data-id="element-151">
                  $19.990 <span className="text-xl" data-id="element-152">ARS</span>
                </span>
              </div>
            </div>

            <div className="flex-grow mb-8" data-id="element-153">
              <ul className="space-y-3 font-montserrat text-sm text-gray-700" data-id="element-154">
                <li className="flex items-start gap-2" data-id="element-155">
                  <span className="text-brand" data-id="element-156">✅</span> Tomo 1: El Arte de
                  Cobrar Caro
                </li>
                <li className="flex items-start gap-2" data-id="element-157">
                  <span className="text-brand" data-id="element-158">✅</span> Tomo 2: 50 Scripts de
                  Reels
                </li>
                <li className="flex items-start gap-2" data-id="element-159">
                  <span className="text-brand" data-id="element-160">✅</span> Tomo 3: Historias que
                  Venden
                </li>
                <li className="flex items-start gap-2" data-id="element-161">
                  <span className="text-brand" data-id="element-162">✅</span> Tomo 4: WhatsApp Closer
                </li>
                <li className="flex items-start gap-2" data-id="element-163">
                  <span className="text-brand" data-id="element-164">✅</span> Tomo 5: Máquina de
                  Re-Agendamiento
                </li>
                <li className="flex items-start gap-2" data-id="element-165">
                  <span className="text-brand" data-id="element-166">✅</span> Tomo 6: Planner de
                  Negocio
                </li>
                <li className="flex items-start gap-2" data-id="element-167">
                  <span className="text-brand" data-id="element-168">✅</span> Bono 1: 100 Ganchos
                  para Reels
                </li>
                <li className="flex items-start gap-2" data-id="element-169">
                  <span className="text-brand" data-id="element-170">✅</span> Bono 2: Fotografía con
                  Celular
                </li>
                <li className="flex items-start gap-2" data-id="element-171">
                  <span className="text-brand" data-id="element-172">✅</span> Bono 3: Guía de Promos
                  Flash
                </li>
                <li className="flex items-start gap-2" data-id="element-173">
                  <span className="text-brand" data-id="element-174">✅</span> Bono 4: Plantillas de
                  Canva
                </li>
              </ul>
            </div>

            <Button variant="primary" className="mb-4" data-id="element-175">
              → QUIERO MI MEGAKIT
            </Button>
            <p className="text-center font-montserrat text-xs text-gray-500" data-id="element-176">
              🛡️ Garantía 7 días · ⚡ Acceso inmediato
            </p>
          </Card>

          {/* Card 2 */}
          <div className="relative h-full" data-id="element-177">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand text-dark font-montserrat font-bold text-xs uppercase tracking-widest py-1 px-4 rounded-full z-10 shadow-md" data-id="element-178">
              ⭐ MÁS ELEGIDA
            </div>
            <Card highlighted className="bg-white flex flex-col h-full relative pt-10" data-id="element-179">
              <div className="mb-6" data-id="element-180">
                <h3 className="font-playfair text-2xl font-bold text-dark mb-2" data-id="element-181">
                  👑 MEGAKIT MÁS CLIENTAS
                  <br data-id="element-182" />+ DUEÑA PRO
                </h3>
                <p className="font-montserrat text-sm font-bold text-brand uppercase tracking-wide mb-4" data-id="element-183">
                  10 Tomos + 4 Bonos
                </p>
                <p className="font-montserrat text-sm text-gray-600 mb-6" data-id="element-184">
                  Ideal para: la profesional que quiere más clientas Y
                  profesionalizarse como dueña de negocio
                </p>
                <div className="flex items-baseline gap-3 mb-6" data-id="element-185">
                  <span className="font-montserrat text-xl text-gray-400 line-through" data-id="element-186">
                    $79.990
                  </span>
                  <span className="font-playfair text-4xl font-bold text-dark" data-id="element-187">
                    $27.990 <span className="text-xl" data-id="element-188">ARS</span>
                  </span>
                </div>
              </div>

              <div className="flex-grow mb-8" data-id="element-189">
                <ul className="space-y-3 font-montserrat text-sm text-gray-700" data-id="element-190">
                  <li className="flex items-start gap-2 font-bold" data-id="element-191">
                    <span className="text-brand" data-id="element-192">✅</span> Todo lo del Megakit
                    principal
                  </li>
                  <li className="flex items-start gap-2" data-id="element-193">
                    <span className="text-brand" data-id="element-194">✅</span> + Tomo 7: La
                    Psicología de la Clienta Difícil
                  </li>
                  <li className="flex items-start gap-2" data-id="element-195">
                    <span className="text-brand" data-id="element-196">✅</span> + Tomo 8: Protocolo
                    de Cancelaciones y Retrasos
                  </li>
                  <li className="flex items-start gap-2" data-id="element-197">
                    <span className="text-brand" data-id="element-198">✅</span> + Tomo 9: Gestión del
                    Tiempo de Dueña
                  </li>
                  <li className="flex items-start gap-2" data-id="element-199">
                    <span className="text-brand" data-id="element-200">✅</span> + Tomo 10: Marca
                    Personal e Identidad de Experta
                  </li>
                </ul>
              </div>

              <Button variant="brand" className="mb-4" data-id="element-201">
                → QUIERO EL MEGAKIT + DUEÑA PRO ⭐
              </Button>
              <p className="text-center font-montserrat text-xs text-gray-500" data-id="element-202">
                🛡️ Garantía 7 días · ⚡ Acceso inmediato
              </p>
            </Card>
          </div>
        </div>

        <p className="text-center font-montserrat text-sm md:text-base text-gray-600 mt-8 max-w-2xl mx-auto" data-id="element-203">
          Por $8.000 más llevás 4 tomos extra que te convierten en dueña del
          negocio. Una sola clienta extra lo paga.
        </p>
      </Section>

      {/* Upsell Details Section */}
      <Section bg="mid" data-id="element-204">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-205">
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-dark mb-4" data-id="element-206">
            👑 ¿Qué agrega DUEÑA PRO?
          </h2>
          <p className="font-montserrat text-lg text-gray-700" data-id="element-207">
            Conseguir más clientas es el primer paso. La dueña de verdad también
            sabe manejar lo que viene después.
          </p>
        </div>

        <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-md overflow-hidden border border-gray-100 mb-12" data-id="element-208">
          <div className="overflow-x-auto" data-id="element-209">
            <table className="w-full text-left font-montserrat" data-id="element-210">
              <thead data-id="element-211">
                <tr className="bg-dark text-base" data-id="element-212">
                  <th className="p-4 md:p-6 font-bold w-1/3" data-id="element-213">Situación real</th>
                  <th className="p-4 md:p-6 font-bold w-1/3 border-l border-gray-700" data-id="element-214">
                    ❌ Sin Dueña Pro
                  </th>
                  <th className="p-4 md:p-6 font-bold w-1/3 border-l border-gray-700 text-brand" data-id="element-215">
                    ✅ Con Dueña Pro
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100" data-id="element-216">
                <tr data-id="element-217">
                  <td className="p-4 md:p-6 font-medium text-dark" data-id="element-218">
                    Una clienta cancela a último momento
                  </td>
                  <td className="p-4 md:p-6 text-gray-600 bg-gray-50" data-id="element-219">
                    Perdés el turno y el ingreso
                  </td>
                  <td className="p-4 md:p-6 font-medium text-dark bg-brand/10" data-id="element-220">
                    Protocolo listo + seña cobrada
                  </td>
                </tr>
                <tr data-id="element-221">
                  <td className="p-4 md:p-6 font-medium text-dark" data-id="element-222">
                    Te negocian el precio
                  </td>
                  <td className="p-4 md:p-6 text-gray-600 bg-gray-50" data-id="element-223">
                    No sabés cómo sostenerlo
                  </td>
                  <td className="p-4 md:p-6 font-medium text-dark bg-brand/10" data-id="element-224">
                    Script exacto para cada caso
                  </td>
                </tr>
                <tr data-id="element-225">
                  <td className="p-4 md:p-6 font-medium text-dark" data-id="element-226">
                    Tu semana es un caos total
                  </td>
                  <td className="p-4 md:p-6 text-gray-600 bg-gray-50" data-id="element-227">
                    Trabajás 12 horas y ganás poco
                  </td>
                  <td className="p-4 md:p-6 font-medium text-dark bg-brand/10" data-id="element-228">
                    Sistema de bloques para trabajar menos y ganar más
                  </td>
                </tr>
                <tr data-id="element-229">
                  <td className="p-4 md:p-6 font-medium text-dark" data-id="element-230">
                    Alguien te pregunta qué te diferencia
                  </td>
                  <td className="p-4 md:p-6 text-gray-600 bg-gray-50" data-id="element-231">
                    No sabés bien qué decir
                  </td>
                  <td className="p-4 md:p-6 font-medium text-dark bg-brand/10" data-id="element-232">
                    Marca personal definida y comunicada
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-12" data-id="element-233">
          <Card className="bg-white border-none shadow-sm" data-id="element-234">
            <h4 className="font-playfair text-lg font-bold text-dark mb-2" data-id="element-235">
              🔴 Tomo 7 — La Psicología de la Clienta Difícil
            </h4>
            <p className="font-montserrat text-sm text-gray-600" data-id="element-236">
              Los 6 perfiles de clienta que te drenan + scripts exactos para
              cada una + sistema de filtros para no atraerlas más.
            </p>
          </Card>
          <Card className="bg-white border-none shadow-sm" data-id="element-237">
            <h4 className="font-playfair text-lg font-bold text-dark mb-2" data-id="element-238">
              🟠 Tomo 8 — Protocolo de Cancelaciones y Retrasos
            </h4>
            <p className="font-montserrat text-sm text-gray-600" data-id="element-239">
              Política completa + sistema de señas + scripts para que nunca más
              un turno vacío te cueste dinero.
            </p>
          </Card>
          <Card className="bg-white border-none shadow-sm" data-id="element-240">
            <h4 className="font-playfair text-lg font-bold text-dark mb-2" data-id="element-241">
              🟡 Tomo 9 — Gestión del Tiempo de Dueña
            </h4>
            <p className="font-montserrat text-sm text-gray-600" data-id="element-242">
              Método de bloques horarios para organizar tu semana y calcular
              cuánto vale realmente tu hora.
            </p>
          </Card>
          <Card className="bg-white border-none shadow-sm" data-id="element-243">
            <h4 className="font-playfair text-lg font-bold text-dark mb-2" data-id="element-244">
              🟢 Tomo 10 — Marca Personal e Identidad de Experta
            </h4>
            <p className="font-montserrat text-sm text-gray-600" data-id="element-245">
              Construí la identidad que te posicione como la referente de tu
              zona y haga que te busquen a vos específicamente.
            </p>
          </Card>
        </div>

        <div className="text-center max-w-2xl mx-auto" data-id="element-246">
          <p className="font-montserrat text-lg font-bold text-dark mb-8" data-id="element-247">
            La diferencia es $8.000. Una sola clienta extra lo paga. Todo lo
            demás es ganancia.
          </p>
          <Button variant="brand" className="w-full md:w-auto md:px-12" data-id="element-248">
            → QUIERO EL MEGAKIT + DUEÑA PRO ⭐
          </Button>
        </div>
      </Section>
    </>;
};